<template>
  <div>
     <Modal
            :mask-closable="false"
            v-model="setAllRoundObj.setAllRoundModal"
            title="全能分项设置"
            :footerHide="true"
            width="470"
            @on-cancel="setAllRoundModalcancel"
        >
        <Form  ref="formValiEditAllRound" :model="formValiEditAllRound" :rules="ruleValidateAllRound" :label-width="90" >
            <CheckboxGroup @on-change="eventChange" v-model="formValiEditAllRound.AllRoundEvent">
                <span class="display-i allroundList" v-for="arr,index in allEventListData" :key="index" >
                  <Checkbox :label="arr.label"></Checkbox>
                </span>
            </CheckboxGroup>
            <div class="UpBut">
                <Button type="primary" size="large" :disabled="disableds"   @click="AllRoundSubmit('ruleValidateAllRound')">保存</Button>
            </div>
        </Form>
    </Modal>
  </div>
</template>
<script>
import {addAllevent,getAllevent} from '@/lib/api/index.js'
export default { 
  /*
    allProp判断如果是全能的选手就不需要名次字段 
    group判断是否为综合成绩
    childTitle传给查看运动员项目的标题
  */
  props: ['setAllRoundObj'],
  data () {
    return {
      formValiEditAllRound:{
        AllRoundEvent:[],
        allPropList:[]
      },
      ruleValidateAllRound:{
      
      },
      allEventListData:[],
      disableds:false,
      allEventType:'',
      allEventLength:'',
    }
  },
  computed: {
   setAllRoundModal()
   {
     return this.setAllRoundObj.setAllRoundModal;
   },
   getResultObj(){
      return this.$store.state.unitAllData.result
   },
  },
  watch: {
    setAllRoundModal()
    {
        let _this = this;
        let data = [];
        this.allEventsex();
        this.formValiEditAllRound.AllRoundEvent = [];
        if(this.setAllRoundObj.setAllRoundModal)
        {
          if(this.getResultObj.event==='十项全能')
          {
            this.allEventType = 10;
          }else if(this.getResultObj.event==='七项全能')
          {
            this.allEventType = 7;
          }else if(this.getResultObj.event==='五项全能')
          {
            this.allEventType = 5;
          }else if(this.getResultObj.event==='三项全能')
          {
            this.allEventType = 3;
          }
          getAllevent(this.setAllRoundObj.sexsorteventID).then(res => {
              if(res.data.code == 0){
                res.data.data.forEach(v=>{
                  this.formValiEditAllRound.AllRoundEvent.push(v.allEvent);
                })
              }else if(res.data.code == -2){
                  this.$Message.error("获取失败");
              }else if(res.data.code==10)
              {
                  this.$Message.info("登录token过期请重新登录");
                  this.$store.dispatch('loginOut');
              }else{
                  this.$Message.error(res.data.msg);
              }
          },err =>{
              this.$Message.error("网络连接失败");
          });
        }
        
    }
  },
  components: {
  }
  ,
  methods: {
    allEventsex()
    {
        let data = [];
        if(this.getResultObj.sexSortName.indexOf('女') !== -1 )
        {
            data = this.$PlugIn.allEvent2;
        }else if(this.getResultObj.sexSortName.indexOf('男') !== -1)
        {
            data = this.$PlugIn.allEvent1;
        }
        
        this.allEventListData = data;
    },
    eventChange(v)
    {
      this.allEventLength = v.length;
      if(this.allEventType<v.length)
      {
        this.$Message.info('最多只能选择'+this.allEventType+'个项目');
      }
    },
    setAllRoundModalcancel()
    {
        this.formValiEditAllRound.AllRoundEvent = []
    },
    AllRoundSubmit(name)
    {
            
            if(this.allEventLength===this.allEventType)
            {
              let data = []
              this.formValiEditAllRound.AllRoundEvent.forEach(item=> {
                this.allEventListData.filter((v)=>{
                  if(v.label===item)
                  {
                    data.push({
                      AllEvent:v.label,
                      allProp:v.value,
                      allNum:v.allNum,
                      sexsorteventID:this.setAllRoundObj.sexsorteventID
                    });
                  }
                })
              });
              
              this.loadings();

              addAllevent(data).then( (res) => {
                  if(res.data.code==0)
                  {
                      this.$Message.info("添加成功");
                      this.disableds = false;
                      
                      this.$Spin.hide();
                      this.$emit('setAllRoundModalShow'); 
                      this.$emit('resultUp');    
                  }else if(res.data.code == -2){
                      this.$Message.error("获取失败");
                      this.$Spin.hide();
                  }else if(res.data.code==10)
                  {
                      this.$Message.info("登录token过期请重新登录");
                      this.$store.dispatch('loginOut');
                  }else{
                      this.$Message.error(res.data.msg);
                      this.$Spin.hide();
                  }
              
              }).catch((error) => {
              })
            }else{
              this.$Message.info("请选择"+this.allEventType+"个项目");
            }
              
  
    }
  },
  created () {
    
  },
  mounted () {
    
  }
}
</script>
<style scoped>
.heightList{padding: 32px 0;}
.allroundList{width:100px;margin-right:8px;padding:12px 0;}
</style>



// WEBPACK FOOTER //
// src/components/setAllRound.vue